export const SAVED_PHRASES_PANEL_TITLE = 'Saved phrases';
export const PLAYLIST_SAVE_TEXT = `Add the video to one of your playlists`;
